import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { productAccessorIsSaeOffer } from './productAccessorIsSaeOffer'

export const productAccessorSomeVariantHasSaeOffer = (
  product: PimProductWithVariantsV1,
): boolean => {
  return product.variants.some((variant) =>
    variant.offers?.some((offer) => productAccessorIsSaeOffer(offer)),
  )
}
